export default "__VITE_ASSET__cOYlka0d__"